// Phone number helpers — consistent (XXX) XXX-XXXX formatting across the platform.

/** Strip everything except digits; drop a leading country-code "1" if present (11 digits). */
export function digitsOnly(value: string | null | undefined): string {
  let d = (value ?? '').replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  return d;
}

/**
 * Display formatter. Returns (XXX) XXX-XXXX when there are exactly 10 digits.
 * Otherwise returns the original value (handles legacy/partial/messy data gracefully).
 */
export function formatPhone(value: string | null | undefined): string {
  if (!value) return '';
  const d = digitsOnly(value);
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  return value;
}

/**
 * Progressive as-you-type mask for input fields. Formats partial input:
 *   ""→"", "12"→"(12", "1234"→"(123) 4", "1234567890"→"(123) 456-7890".
 * Caps at 10 digits.
 */
export function formatPhoneInput(value: string): string {
  const d = digitsOnly(value).slice(0, 10);
  if (d.length === 0) return '';
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** Valid when empty (phone is optional) or exactly 10 digits. */
export function isValidPhone(value: string | null | undefined): boolean {
  const d = digitsOnly(value);
  return d.length === 0 || d.length === 10;
}
